export default {
  methods: {
    getPickLists(pick_list_matrix) {
      let v = null
      Object.keys(pick_list_matrix).forEach((pl_key) => {
        const pl_val = pick_list_matrix[pl_key]
        const pick_list = []
        Object.keys(pl_val.pick_lists).forEach((k) => {
          const v = pl_val.pick_lists[k]
          pick_list.push(v)
        })
        v = {
          defaults: pl_val.defaults,
          pick_lists: pick_list,
        }
      })
      return v
    },
    getPriceList(price_matrix) {
      let v = null
      Object.keys(price_matrix).forEach((k) => {
        v = price_matrix[k]
      })
      return v
    },
    getNutritionInfo(nutrition_matrix, withStyle = false, styleCode = 0) {
      let v = null
      if (withStyle) {
        Object.keys(nutrition_matrix).forEach((k) => {
          if (k == styleCode) v = nutrition_matrix[k]
        })
        delete v.allergens
        if (Object.keys(v).length === 0) {
          v = null
        }
        return v
      }
      if (Object.keys(nutrition_matrix).length == 0) {
        return v
      }
      Object.keys(nutrition_matrix).forEach((k) => {
        v = nutrition_matrix[k]
      })
      delete v.allergens
      if (Object.keys(v).length === 0) {
        v = null
      }
      return v
    },
    normalizeAddons(data) {
      let sizes = []
      let singleItem = {}
      let pricelist = []
      let minPrice = 9999999999999

      if (data.sizes?.length > 0) {
        sizes = data.sizes
      }

      singleItem.sizes = false
      singleItem.styles = false
      singleItem.images = data.image_urls
      singleItem.item_id = data.item_id
      singleItem.item_name = data.item_name
      singleItem.calories = []
      Object.keys((data && data.pricelist) || {}).forEach((price_key) => {
        let price_val = data.pricelist[price_key]
        if (minPrice > price_val.display_price) {
          minPrice = price_val.display_price
          singleItem.prices = {
            baseprice: data.pricelist[0].baseprice,
            display_price: data.pricelist[0].display_price,
            no_surcharge_price: data.pricelist[0].no_surcharge_price,
          }
        }
        let calorieData = {
          min_calorie: data.pricelist[price_key].min_calories,
          max_calorie: data.pricelist[price_key].max_calories,
        }
        singleItem.calories.push(calorieData)
      })

      singleItem.long_description = data.long_description
      singleItem.addOn = []
      Object.keys((data && data.pricelist) || {}).forEach((k) => {
        let itemPrices = data.pricelist[k]
        pricelist[itemPrices['item_size_id']] = itemPrices
      })

      if (sizes.length > 0) {
        singleItem.sizes = true
        Object.keys(sizes).forEach((k) => {
          let itemSizes = sizes[k]

          if (typeof data.styles !== 'undefined' && data.styles.length > 0) {
            singleItem.styles = true

            let stylesData = []

            Object.keys(data.styles).forEach((style_key) => {
              let priceList2 = []
              if (
                typeof data.pick_list_matrix[itemSizes['sizeid']][data.styles[style_key]['style_id']] != 'undefined'
              ) {
                Object.keys((data && data.pricelist) || {}).forEach((k) => {
                  if (
                    data.pricelist[k]['item_size_id'] == itemSizes['sizeid'] &&
                    data.pricelist[k]['item_style_id'] == data.styles[style_key]['style_id']
                  ) {
                    priceList2 = data.pricelist[k]
                  }
                })

                stylesData[style_key] = {
                  priceList: priceList2,
                  prices: this.getPriceList(data.price_matrix[itemSizes['sizeid']]),
                  detail: data.styles[style_key],
                  sub: this.getPickLists(data.pick_list_matrix[itemSizes['sizeid']]),
                  nutrition: this.getNutritionInfo(
                    data.nutrition_matrix[itemSizes['sizeid']],
                    true,
                    data.styles[style_key]['style_id'] ?? 0
                  ),
                }
              }
            })

            Object.keys((data && data.pricelist) || {}).forEach((k) => {
              let itemPrices = data.pricelist[k]
              pricelist[itemPrices['item_size_id']] = itemPrices
            })

            singleItem.addOn[k] = {
              sizename: itemSizes['sizename'],
              sizeid: itemSizes['sizeid'],
              priceList: pricelist[itemSizes['sizeid']],
              prices: this.getPriceList(data.price_matrix[itemSizes['sizeid']]),
              styleList: stylesData,
              style: true,
              nutrition: this.getNutritionInfo(data.nutrition_matrix[itemSizes['sizeid']]),
            }
          } else {
            singleItem.addOn[k] = {
              sizename: itemSizes['sizename'],
              sizeid: itemSizes['sizeid'],
              priceList: pricelist[itemSizes['sizeid']],
              prices: this.getPriceList(data.price_matrix[itemSizes['sizeid']]),
              sub: this.getPickLists(data.pick_list_matrix[itemSizes['sizeid']]),
              style: false,
              nutrition: this.getNutritionInfo(data.nutrition_matrix[itemSizes['sizeid']]),
            }
          }
        })
      } else {
        Object.keys(data.pick_list_matrix).forEach((k) => {
          let v = data.pick_list_matrix[k]
          singleItem.addOn = this.getPickLists(v)
          singleItem.nutrition = this.getNutritionInfo(data.nutrition_matrix[k])
        })
      }
      return singleItem
    },
  },
}
